import { render } from "./Logo.vue?vue&type=template&id=4194985e&scoped=true&lang=html"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=4194985e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4194985e"]])

export default __exports__